export const buildComparisonStats = (battle) => {
  if (battle?.comparisonStats) {
    return {
      votesA: battle.comparisonStats.votesA || 0,
      votesB: battle.comparisonStats.votesB || 0,
      totalVotes: battle.comparisonStats.totalVotes || 0,
      percentA: battle.comparisonStats.percentA || 0,
      percentB: battle.comparisonStats.percentB || 0,
      userVote: battle.comparisonStats.userVote || null,
    };
  }

  const votesA = battle?.votesA || 0;
  const votesB = battle?.votesB || 0;
  const totalVotes = battle?.totalVotes || votesA + votesB;

  return {
    votesA,
    votesB,
    totalVotes,
    percentA: totalVotes ? Math.round((votesA / totalVotes) * 100) : 0,
    percentB: totalVotes ? Math.round((votesB / totalVotes) * 100) : 0,
    userVote: null,
  };
};

export const calculateNextComparisonStats = (currentStats, nextOption) => {
  const previousOption = currentStats?.userVote || null;
  let votesA = Number(currentStats?.votesA || 0);
  let votesB = Number(currentStats?.votesB || 0);

  if (previousOption === "A") votesA = Math.max(0, votesA - 1);
  if (previousOption === "B") votesB = Math.max(0, votesB - 1);
  if (nextOption === "A") votesA += 1;
  if (nextOption === "B") votesB += 1;

  const totalVotes = votesA + votesB;
  return {
    votesA,
    votesB,
    totalVotes,
    percentA: totalVotes ? Math.round((votesA / totalVotes) * 100) : 0,
    percentB: totalVotes ? Math.round((votesB / totalVotes) * 100) : 0,
    userVote: nextOption,
  };
};

export const mergeBattleWithComparisonStats = (battle, comparisonStats) => ({
  ...battle,
  comparisonStats,
  totalVotes: comparisonStats.totalVotes,
  votesA: comparisonStats.votesA,
  votesB: comparisonStats.votesB,
});
